export enum ProductCategory {
  Goods = 'GOODS',
  Work = 'WORK',
}
